import { Grid, InputAdornment, MenuItem, TextField, Typography } from '@mui/material'
import { BillingsWithCashFlow, Discount } from '../CashFlow'
import { allowFloat, allowMoneyFormat, formatNumberToMoney } from '../../../../Utils'

type Props = {
  error: boolean
  form: BillingsWithCashFlow
  netValue: number
  updateDiscount: (updates: Partial<Discount>) => void
}

export default function DiscountComponent({ error, form, netValue, updateDiscount }: Props) {
  return <>
    <Grid item xs={12}>
      <Typography>
        Discount
      </Typography>
    </Grid>
    <Grid item xs={6}>
      <TextField
        id='form-field-discount-type'
        label='Discount type'
        value={form.discount.type}
        onChange={(e) => updateDiscount({ type: e.target.value as typeof form.discount.type })}
        select
      >
        <MenuItem id={'discount-type-percentage'} value='percentage'>% (Percentage)</MenuItem>
        <MenuItem id={'discount-type-setValue'} value='setValue'>{form.billing.currency.sign} (Set value)</MenuItem>
      </TextField>
    </Grid>
    <Grid item xs={6}>
      <TextField
        id='form-field-discount-value'
        label='Discount'
        value={form.discount[form.discount.type].label}
        onChange={(e) => form.discount.type === 'percentage' ?
          updateDiscount({
            percentage: {
              value: allowFloat(e.target.value.trim()),
              label: e.target.value.trim()
            }
          })
          :
          updateDiscount({
            setValue: {
              value: allowMoneyFormat(e.target.value.trim()),
              label: e.target.value.trim()
            }
          })
        }
        error={error}
        onBlur={() => {
          if (form.discount.type === 'setValue' && !isNaN(form.discount.setValue.value)) {
            updateDiscount({
              setValue: {
                ...form.discount.setValue,
                label: formatNumberToMoney(form.discount.setValue.value)
              }
            })
          }
        }}
        onFocus={() => {
          if (form.discount.type === 'setValue' && form.discount.setValue.value) {
            updateDiscount({
              setValue: {
                ...form.discount.setValue,
                label: form.discount.setValue.value.toFixed(2)
              }
            })
          }
        }}
        InputProps={
          form.discount.type === 'percentage' ?
            { endAdornment: <InputAdornment position='start'>%</InputAdornment> } // position="start" looks better
            :
            { startAdornment: <InputAdornment position='start'>{form.billing.currency.sign}</InputAdornment> }
        }
      />
    </Grid>
    <Grid item xs={12}>
      {
        form.discount.type === 'percentage' && netValue !== form.billing.totalBilling.value && !isNaN(netValue) ?
          <Typography id='form-label-due-value-after-discount' textAlign={'right'}>
            Net value: <b>{form.billing.currency.sign} {netValue}</b> (w/ discount)
          </Typography>
          :
          <></>
      }
      {
        form.discount.type === 'setValue' && form.discount.setValue.value && !isNaN(form.discount.setValue.value) && netValue !== form.billing.totalBilling.value ?
          <Typography id='form-label-due-value-after-discount' textAlign={'right'}>
            Net value: <b>{form.billing.currency.sign} {netValue}</b> ({form.cashFlowOptions.numberOfBills.value} installments)
          </Typography>
          :
          <></>
      }
    </Grid>
  </>
}
